import $ from 'jquery' /*引入jquery*/
import {checkLogin,loginFromM,appid} from '../common/login.js'
import getURLParameter from '../common/getURLParameter.js'

export default function(){
	$('.bottom-bar').on('click','.bottom-item',bottomItemClick)
}

let urlParam = getURLParameter();
let indexUrl = '//luna.58.com/m/autotemplate?city=bj&creativeid=40&PGTID=0d200000-0000-1271-bd82-fdbe923aa41e&ClickID=1'
let messageUrl = `//im.m.58.com/index?client_type=wap_tcb&user_source=2&appid=${appid}#/entry/`
let mineUrl = `//luna.58.com/my_center.shtml?city=${urlParam.city}&creativeid=${urlParam.creativeid}`
function bottomItemClick(e){
    // if($(this).hasClass('active')){
    //     return
    // }
    // $(this).addClass('active').siblings().removeClass('active')
    // if($(this).hasClass('index')){
    //     window.location.href = indexUrl
    // }
    if($(this).hasClass('message')){    
        checkLogin(function(data){
            if(data.userid > 0){
                window.location.href = messageUrl
            }else{
                const url = `https:${messageUrl}`;
                loginFromM({url:url})
            }
        })
    }
    if($(this).hasClass('mine')){
        window.location.href = mineUrl
    }
}